

























































































import { Mixins, Component } from 'vue-property-decorator';
import { AxPage } from '@/mixins';
import * as I from '@/interfaces';

interface Base {
  seqNo: number;
}

type PickProp =
  | 'seqNo'
  | 'tempName'
  | 'tempCardNo'
  | 'name'
  | 'empNo'
  | 'companyName'
  | 'issueDateTime';

type StaffTable = Pick<I.TempStaffHistoryList, PickProp>;

type TableHeader<T> = { [P in keyof T]: string };

const header: TableHeader<StaffTable> = {
  seqNo: '순번',
  tempName: '카드명',
  tempCardNo: '카드번호',
  name: '이름',
  empNo: '사원번호',
  companyName: '사원 정보',
  issueDateTime: '발급시간'
};

@Component
export default class extends Mixins(AxPage) {
  state = {
    issueVisible: false,
    itemList: [],
    tab: null,
    tabItems: [
      { tab: 'One', content: 'Tab 1 Content' },
      { tab: 'Two', content: 'Tab 2 Content' },
      { tab: 'Three', content: 'Tab 3 Content' },
      { tab: 'Four', content: 'Tab 4 Content' },
      { tab: 'Five', content: 'Tab 5 Content' },
      { tab: 'Six', content: 'Tab 6 Content' },
      { tab: 'Seven', content: 'Tab 7 Content' },
      { tab: 'Eight', content: 'Tab 8 Content' },
      { tab: 'Nine', content: 'Tab 9 Content' }
    ]
  };

  staffList: I.TempStaffHistoryList[] = [];

  async prepare() {
    const baseData = await this.getBaseData();
    console.log(baseData);
    if (baseData) {
      this.staffList = baseData.sort(x => x.seqNo).reverse();
    }
  }

  async getBaseData() {
    const result = await this.API.call.temp.staffGet('');
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }
  test = '1234';
  search = '';

  get headers() {
    return Object.entries(header).map(([value, text]) => {
      return { text, value };
    });
  }

  async onSearch() {
    const result = await this.API.call.temp.staffGet(this.search);
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      if (result) {
        this.staffList = result.data.sort(x => x.seqNo).reverse();
      }
    }
  }

  onAddClicked() {
    const callback = async () => {
      await this.onSearch();
    };

    this.showDialog({
      type: 'AxTempStaffNewDialog',
      props: {
        callback
      }
    });
  }

  onRetrunClick(staffList: I.TempStaffHistoryList) {
    const callback = async () => {
      await this.onSearch();
    };

    this.showDialog({
      type: 'AxTempStaffReturnDialog',
      props: {
        staffList,
        callback
      }
    });
  }

  onHistoryClicked() {
    const callback = async () => {
      await this.onSearch();
    };

    this.showDialog({
      type: 'AxTempStaffHistoryDialog',
      //type: 'AxUserRegisterDialog',
      props: {
        callback
      }
    });
  }

  async onRowItemClicked(item: I.TempStaffHistoryList) {
    const tempItem = item as I.TempStaffHistoryList;
    const result = await this.showConfirmModal(
      '확인',
      `사원번호 : ${tempItem.empNo}<br />성명 : ${tempItem.name}<br />임시증 : ${tempItem.tempName}<br /><br />선택된 내역을 반납하시겠습니까?`
    );
    if (result === 0) {
      this.onRetrunClick(item);
    }
  }
}
